angular
    .module('annexaApp')
    .component('annexaDocumentExternal', {
        templateUrl: './components/doc/annexa-document-external/annexa-document-external.html',
        require: {
            documentComponentBasicInfo: '^^annexaDocumentBasicInfoBox'
        },
        controller: ['$rootScope', 'Language', '$filter', 'DccumentsFactory', 'GlobalDataFactory', 'CommonService', 'DialogsFactory', 'RestService', 'HelperService', 'globalModals', 'AnnexaFormlyFactory', function ($rootScope, Language, $filter, DccumentsFactory, GlobalDataFactory, CommonService, DialogsFactory, RestService, HelperService, globalModals, AnnexaFormlyFactory) {
            var vm = this;
            vm.canShow = false;
            vm.canEdit = false;
            vm.linkLiteral = $filter('translate')('global.literals.see');
            vm.permissions = 'edit_document';
            vm.openWindow = function(){
            	if(vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.document && vm.documentComponentBasicInfo.documentComponent.document.digitalUrl){
            		window.open(vm.documentComponentBasicInfo.documentComponent.document.digitalUrl);
            	}
            }
            
            vm.editFunction = function(){
            	if(vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.document && vm.documentComponentBasicInfo.documentComponent.document.showDigital){
            		var modal = angular.copy(globalModals.editDigitalDocument);
                    modal.annexaFormly.model = {};
                    modal.annexaFormly.model.modal_body = {};
                    modal.annexaFormly.options = {};
                    modal.annexaFormly.options.formState = {readOnly: false};
                    modal.annexaFormly.model.modal_body = {
                    	digitalUrl: ((vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.document && vm.documentComponentBasicInfo.documentComponent.document.digitalUrl)?angular.copy(vm.documentComponentBasicInfo.documentComponent.document.digitalUrl):undefined), 
                    	digitalName:((vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.document && vm.documentComponentBasicInfo.documentComponent.document.digitalName)?angular.copy(vm.documentComponentBasicInfo.documentComponent.document.digitalName):undefined)
                    };
                    modal.alerts = [];
                    var submitFunction = function(){
                    	var self = this;
						if(self && self.annexaFormly && self.annexaFormly.model && self.annexaFormly.model.modal_body && self.annexaFormly.model.modal_body.digitalUrl){
							if(vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.updateDocument){
								var model = angular.copy(self.annexaFormly.model.modal_body);
								model.modal = self;
								vm.documentComponentBasicInfo.documentComponent.updateDocument(model, 'digitalProperties', true);
							}else{
								self.close();
							}
						}else{
							self.close();
						}
                    }
                    AnnexaFormlyFactory.showModal('modalEditDigitalDocument', modal, submitFunction, false);
            	}
            }
            
			this.$onInit = function() {
            	vm.canShow = ((vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.document && vm.documentComponentBasicInfo.documentComponent.document.digitalUrl)?true:false);
            	vm.canEdit = ((vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.canEdit)?true:false);
            	if(vm.documentComponentBasicInfo && vm.documentComponentBasicInfo.documentComponent && vm.documentComponentBasicInfo.documentComponent.document){
            		if(vm.documentComponentBasicInfo.documentComponent.document.digitalName){
            			vm.linkLiteral = vm.documentComponentBasicInfo.documentComponent.document.digitalName;
            		}else if(vm.documentComponentBasicInfo.documentComponent.document.name){
            			vm.linkLiteral = vm.documentComponentBasicInfo.documentComponent.document.name;
            		}else{
            			vm.linkLiteral = $filter('translate')('global.literals.see');
            		}
            	}else{
            		vm.linkLiteral = $filter('translate')('global.literals.see');
            	}
            }
        }]
    })